import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarBackIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.6523 12.5595V13.5683H17.2736V8.25042C14.2545 6.77435 9.59991 5.03204 9.59991 5.03204C8.92511 4.7594 8.21081 4.60235 7.48547 4.56787L3.20953 4.56689V16.9999L6.5968 16.9577C8.20801 20.5569 13.0533 20.0684 14.0509 16.3352L16.5454 15.2089H20.293V12.5595H18.6524H18.6523ZM15.6336 13.8212L12.6437 15.1711C12.2593 18.5211 8.41161 18.6229 7.68993 15.3177H4.84453V6.20684H7.42443C7.9602 6.23424 8.48534 6.35052 8.9854 6.55254C8.9854 6.55254 13.1052 8.12047 15.6336 9.32769V13.8212H15.6336Z" />
    </SvgIcon>
  );
});
